import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

const Auth = () => {
  const { login, signup } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState("login");
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", phone: "", password: "" });
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === "login") {
        await login(form.email, form.password);
        toast.success("Welcome back!");
      } else {
        if (!form.first_name || !form.last_name) { toast.error("Please add your name"); setLoading(false); return; }
        await signup(form);
        toast.success("Account created!");
      }
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 pt-24 pb-24">
      <h1 className="font-heading text-3xl font-bold text-[#2c1e12] text-center">{mode === "login" ? "Welcome back" : "Create your account"}</h1>
      <p className="text-center text-[#8a7458] mt-1">{mode === "login" ? "Sign in to order and earn rewards" : "Join TABLE24 and start earning rewards"}</p>

      <form onSubmit={submit} className="mt-6 space-y-3">
        {mode === "signup" && (
          <div className="grid grid-cols-2 gap-3">
            <Input placeholder="First name" value={form.first_name} onChange={set("first_name")} />
            <Input placeholder="Last name" value={form.last_name} onChange={set("last_name")} />
          </div>
        )}
        <Input type="email" placeholder="Email" value={form.email} onChange={set("email")} />
        {mode === "signup" && <Input placeholder="Phone number" value={form.phone} onChange={set("phone")} />}
        <Input type="password" placeholder="Password" value={form.password} onChange={set("password")} />
        <button disabled={loading} className="w-full rounded-xl bg-[#9a4a2f] hover:bg-[#853e26] disabled:opacity-60 text-white font-semibold py-3.5 transition-colors">
          {loading ? "Please wait…" : mode === "login" ? "Sign In" : "Sign Up"}
        </button>
      </form>

      <p className="text-center text-sm text-[#8a7458] mt-4">
        {mode === "login" ? "New to TABLE24?" : "Already have an account?"}{" "}
        <button onClick={() => setMode(mode === "login" ? "signup" : "login")} className="text-[#9a4a2f] font-semibold">
          {mode === "login" ? "Create an account" : "Sign in"}
        </button>
      </p>
    </div>
  );
};

const Input = ({ type = "text", ...props }) => (
  <input type={type} {...props} className="w-full rounded-xl bg-[#f6ece0] border border-[#e6d8bf] px-4 py-3 text-[#2c1e12] focus:outline-none focus:ring-2 focus:ring-[#9a4a2f]/40" />
);

export default Auth;
